export default __webpack_public_path__ + "e3ed6bcbf4e6f28f222e9535c960d4f0.png";